import React from 'react';
import {Route, Navigate} from 'react-router-dom';
import home from './home/routes';
import finder from './finder/routes';
import debug from './debug/routes';

export default [
  <Route
    key="/business/showcase/shadefinder/"
    path="business/showcase/shadefinder"
    element={<Navigate to="../business/showcase/shadefinder/home" replace />}
  />,
  home,
  finder,
  debug,
];
